import { CommentInput } from "./CommentInput";
import { CommentText } from "./CommentText";

export { CommentInput, CommentText };
